import React, {useEffect, useState} from 'react';
import {useLocation, useSearchParams, Routes, Route, useParams} from 'react-router-dom';
import Main from './components/main/main';
import InvalidUrl from "./components/404/invalidUrl";
import ErrorUrl from "./components/404/errorUrl";
import YandexMetrik from "./components/yandexMetrik";
import {Helmet} from 'react-helmet-async';
import {setData} from "./store/slices/dataSlice";
import {useAppDispatch} from "./hooks";
import Loader from "./components/ui/loader";
import PdfLoadingPage from "./components/pdf-gen/pdf-loading-page";
import { proxyImageUrls } from './helpers/imageProxy';

type AppProps = {
    previewOnly?: boolean;
    download?: boolean;
};

const App: React.FC<AppProps> = () => {
    const api = process.env.REACT_APP_BACK_URL
    const [searchParams, ] = useSearchParams();
    const { uuid } = useParams();
    const [loading, setLoading] = useState(false);
    const [errorPage, setErrorPage] = useState<any>();
    const [errorTitle, setErrorTitle] = useState<string>();
    const builderHouse = searchParams.get('builder');
    const [data2, setData2] = useState<any>();
    const location = useLocation();
    const dispatch = useAppDispatch();

    // Проверяем, есть ли "download" в пути
    const hasDownloadRoute = location.pathname.includes('/download');

    useEffect(() => {
        const fetchData = async () => {
            const url = `${api}/estate/selections/presentation/${uuid}`;
            const dataUrl = await fetch(url, {
                method: 'GET',
                headers: {
                    accept: 'application/json',
                },
            }).then(async data => {
                const res: any = await data.json()
                if(location.pathname === '/pdf-loading' && Boolean(res.message)) return

                if (!res.statusCode && !res.message) {
                    setErrorPage(null)
                    // Применяем прокси к изображениям
                    const processedRes = proxyImageUrls(res);
                    return processedRes
                } else {
                    if(res.message === 'Указанные данные были неверными.'){
                        setErrorPage(<InvalidUrl/>)
                        setErrorTitle(res.message)
                        return undefined

                    }
                    if(res.message === 'Ресурс не найден.'){
                        setErrorPage(<ErrorUrl/>)
                        setErrorTitle(res.message)
                        return undefined
                    }
                    if (res.statusCode === 404) {
                        setErrorPage(<InvalidUrl/>)
                        setErrorTitle(res.statusCode)
                        return undefined
                    }
                    if (res.message === 'Server Error') {
                        setErrorTitle(res.message)
                        setErrorPage(<InvalidUrl/>)
                        return undefined
                    }
                    setErrorPage(<InvalidUrl/>)
                }
            }).catch(err => console.log(err));
            setLoading(true);
            setData2(dataUrl);
        };
        fetchData();
    }, []);

    useEffect(() => {
        dispatch(setData(data2));
    }, [data2]);

    const titleSEO = `Презентация недвижимости`

    // const descSEO = !builderHouse ?
    //     data2?.apartment?.housing_complex?.description.replace(/^\s*[\r\n]/gm, '').replace(/<\/?[^>]+>/g,'').slice(0, 220)
    //     :
    //     data2?.housing_complex?.description.replace(/^\s*[\r\n]/gm, '').replace(/<\/?[^>]+>/g,'').slice(0, 220)

    return (
        <>
            <Helmet title={errorPage ? 'Ошибка: ' + errorTitle : titleSEO} htmlAttributes={{ lang: 'en' }}>
                <meta property="og:title" content={titleSEO} />
                {/*<meta property="og:description" content={descSEO} />*/}
            </Helmet>

            {errorPage ? (
                errorPage
            ) : (
                <>
                    <Routes>
                        <Route
                            path=""
                            element={
                                <div className={loading ?
                                    'wrapper mx-auto max-md:max-w-[1280px] max-md:w-full max-md:px-[12px]'
                                    : 'wrapper w-full h-[100vh] flex items-center justify-center'}>
                                    {!loading && <Loader text={'загружаем страницу...'} />}
                                    {data2 !== undefined && <Main data={data2.data} hasDownloadRoute={hasDownloadRoute}/>}
                                </div>
                            }
                        />

                        <Route path="download" element={<PdfLoadingPage data={data2} hasDownloadRoute={hasDownloadRoute} dataClient={data2?.data?.client}/>} />

                        <Route path="*" element={<InvalidUrl />} />
                    </Routes>

                    <YandexMetrik />
                </>
            )}
        </>
    );
}

export default App;
